import React from 'react';
import { BaseModal } from 'src/design/molecules/BaseModal';
import { ScimIntegrationDto } from 'src/api/FiretrolApiClient';
import { ScimIntegrationForm } from './ScimIntegrationForm';

interface ScimIntegrationDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  integration: ScimIntegrationDto | null;
}

export const ScimIntegrationDialog: React.FC<ScimIntegrationDialogProps> = ({
  open,
  onClose,
  onSave,
  integration,
}) => {
  return (
    <BaseModal
      opened={open}
      onClose={onClose}
      title={integration ? 'Update Integration' : 'Create New Integration'}
      size="xl"
      centered
    >
      <ScimIntegrationForm
        onClose={onClose}
        onSave={onSave}
        integration={integration}
      />
    </BaseModal>
  );
};
